/** 検索キー名の最大文字数 */
export const TRACE_KEY_NAME_MAX_LENGTH = 30
